import React, { useEffect } from 'react';
import axios from 'axios';
import { env, REACT_APP_SERVER_API } from 'src/config';
import { getHeaders } from 'src/common';
import { Content, Header, Footer } from 'src/components/home';
import { FooterMenu } from 'src/components/home/FooterMenu';
import { PopUp } from 'src/components/home/PopUp';
import { useTheme } from 'src/providers/Theme';

const HomeLayout = () => {
  const { theme } = useTheme();
  useEffect(() => {
    const ping = () => {
      if (document.visibilityState === 'hidden') return;
      if (!localStorage.getItem('access_token')) return;
      axios.post(env(REACT_APP_SERVER_API) + 'user/activity', {}, { headers: getHeaders() })
        .catch(() => { /* Logging must not block the catalog. */ });
    };
    ping();
    const interval = setInterval(ping, 5 * 60 * 1000);
    document.addEventListener('visibilitychange', ping);
    return () => { clearInterval(interval); document.removeEventListener('visibilitychange', ping); };
  }, []);
  return (
    <div data-theme={theme} id='page'>
      <Header />
      <div className={'body flex-grow-1 px-3 ' + theme}>
        <Content />
      </div>
      <FooterMenu />
      {/* <Footer /> */}
      <PopUp />
    </div>
  );
};

export default HomeLayout;
